import { z } from 'my-zod'
import { outfitterOrderHeadersModel } from './outfitter-order-headers-model'
import { outfitterOrderHeaderSystemView } from './outfitter-order-system-view'

export const upsertOutfitterOrderRequestModel = outfitterOrderHeadersModel.augment({
  id: z.number().nullish(),
  shortId: z.string().nullish()
})

export type upsertOutfitterOrderRequestModel = z.infer<typeof upsertOutfitterOrderRequestModel>

export const upsertOutfitterOrderRequestView = outfitterOrderHeaderSystemView.augment({
  id: z.number().nullish(),
  shortId: z.string().nullish()
})

export type upsertOutfitterOrderRequestView = z.infer<typeof upsertOutfitterOrderRequestView>
